module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('login.cta')))]), _c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_c('ed-input', {
    attrs: {
      "name": "username",
      "type": "email",
      "field-label": _vm.$t("login.Email"),
      "placeholder": _vm.$t("login.emailHint")
    },
    model: {
      value: (_vm.loginDetails.username),
      callback: function($$v) {
        _vm.$set(_vm.loginDetails, "username", $$v)
      },
      expression: "loginDetails.username"
    }
  }), _c('ed-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "show-password": "",
      "field-label": _vm.$t("login.Password"),
      "placeholder": _vm.$t("login.passwordHint")
    },
    model: {
      value: (_vm.loginDetails.password),
      callback: function($$v) {
        _vm.$set(_vm.loginDetails, "password", $$v)
      },
      expression: "loginDetails.password"
    }
  }), _c('button', {
    staticClass: "btn btn-primary float-right pull-right",
    attrs: {
      "type": "submit",
      "value": "login",
      "endpoint": this.api.$.login
    }
  }, [_vm._v(_vm._s(_vm.$t('login.button')))]), (_vm.loginError.message) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.loginError.message)))]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa308fc6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/index.vue
// module id = KQeq
// module chunks = 13 14